import React, { useEffect } from 'react';
import { getNotifications } from '../../services/api';
import { useNotifications } from '../../context/NotificationContext';
import { useWebSocketNotifications } from '../../hooks/useWebSocketNotifications';
import { log, error } from '../../utils/logger';

/**
 * NotificationService component that initializes WebSocket
 * notification system and polling. This component doesn't render anything visible.
 */
export const NotificationService: React.FC = () => {
  // Initialize WebSocket for real-time notifications
  useWebSocketNotifications();
  
  // Get updateNotifications from context
  const { updateNotifications } = useNotifications();
  
  // Fetch notifications on initial load and poll as a fallback to WebSocket.
  useEffect(() => {
    let isFetching = false;

    const fetchInitialNotifications = async () => {
      if (isFetching) {
        return;
      }

      try {
        // Skip if we're on login page
        if (window.location.pathname === '/login') {
          return;
        }

        isFetching = true;
        log('Fetching initial notifications...');
        const notificationResponse = await getNotifications(10, 0);
        updateNotifications(notificationResponse.notifications, notificationResponse.total);
        log('Initial notifications fetched successfully:', notificationResponse.notifications.length);
      } catch (err) {
        error('Failed to fetch initial notifications:', err);
      } finally {
        isFetching = false;
      }
    };
    
    // Fetch immediately, then refresh every 20 seconds.
    fetchInitialNotifications();
    const pollingInterval = window.setInterval(fetchInitialNotifications, 20_000);

    return () => {
      window.clearInterval(pollingInterval);
    };
  }, [updateNotifications]);
  
  // This component doesn't render anything visible
  return null;
};

export default NotificationService;
